import './contact.css'
import Menu from '../../components/menu/menu'
import React, { useState } from "react";
import { BiMailSend, BiPhoneCall, BiLogoWhatsapp } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import emailjs from "@emailjs/browser"
import Swal from 'sweetalert2'

const Contact = () => {
    const [nome, setNome] = useState('')
    const [email, setEmail] = useState('')
    const [assunto, setAssunto] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [errors, setErrors] = useState({ nome: '', email: '', assunto: '' })

    const validateField = (field, value) => {
        let message = ''
        
        if (!value.trim()) {
            message = 'Este campo é obrigatório.'
        } else if (field === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(value)) {
                message = 'Por favor, insira um e-mail válido.'
            }
        } else if (field === 'assunto' && value.trim().length < 10) {
            message = 'A mensagem deve ter pelo menos 10 caracteres.'
        }
        
        setErrors(prev => ({ ...prev, [field]: message }))
        return !message
    }

    function sendMail(e) {
        e.preventDefault()
        
        const isNomeValid = validateField('nome', nome)
        const isEmailValid = validateField('email', email)
        const isAssuntoValid = validateField('assunto', assunto)

        if (!isNomeValid || !isEmailValid || !isAssuntoValid) {
            Swal.fire({
                icon: 'warning',
                title: 'Formulário incompleto',
                text: 'Por favor, corrija os erros acima e tente novamente.',
                confirmButtonColor: '#0b5cff',
                iconColor: '#ff6b6b'
            })
            return
        }

        Swal.fire({
            title: 'Confirmar envio',
            text: `Deseja enviar sua mensagem, ${nome}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0b5cff',
            cancelButtonColor: '#ff6b6b',
            confirmButtonText: 'Sim, enviar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true)
                
                const emailParams = {
                    from_name: nome,
                    message: assunto,
                    email: email
                }

                emailjs.send(
                    "service_qgqj9dq",
                    "template_wij6115",
                    emailParams,
                    "Rn3bMroaX6cLH8evD"
                ).then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Enviado com sucesso!',
                        text: 'Obrigado! Sua mensagem foi recebida. Entraremos em contato em breve.',
                        confirmButtonColor: '#0b5cff'
                    })
                    setNome('')
                    setEmail('')
                    setAssunto('')
                    setErrors({ nome: '', email: '', assunto: '' })
                }).catch((error) => {
                    console.error('Erro:', error)
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro ao enviar',
                        text: 'Ocorreu um erro. Por favor, tente novamente mais tarde.',
                        confirmButtonColor: '#0b5cff'
                    })
                }).finally(() => {
                    setIsLoading(false)
                })
            }
        })
    }

    return (
        <div>
            <Menu url="contact" />
            <main className="contact-page">
                <div className="contact-container">
                    <section className="contact-section">
                        {/* Header */}
                        <header className="contact-header">
                            <h1 className="contact-title">
                                Entre em Contato
                            </h1>
                            <p className="contact-subtitle">
                                Tem uma pergunta ou proposta? Adorarei ouvir de você!
                            </p>
                            <div className="title-divider"></div>
                        </header>

                        {/* Wrapper */}
                        <div className="contact-wrapper">
                            {/* Formulário */}
                            <div className="contact-form-section">
                                <form onSubmit={sendMail} className="contact-form" noValidate>
                                    {/* Campo Nome */}
                                    <div className="form-group">
                                        <div className="form-input-wrapper">
                                            <input
                                                type="text"
                                                className="form-input"
                                                placeholder=" "
                                                value={nome}
                                                onChange={(e) => {
                                                    setNome(e.target.value)
                                                    if (errors.nome) validateField('nome', e.target.value)
                                                }}
                                                onBlur={(e) => validateField('nome', e.target.value)}
                                                disabled={isLoading}
                                            />
                                            <label className="form-label">Nome completo *</label>
                                        </div>
                                        {errors.nome && <span className="error-message">{errors.nome}</span>}
                                    </div>

                                    {/* Campo Email */}
                                    <div className="form-group">
                                        <div className="form-input-wrapper">
                                            <input
                                                type="email"
                                                className="form-input"
                                                placeholder=" "
                                                value={email}
                                                onChange={(e) => {
                                                    setEmail(e.target.value)
                                                    if (errors.email) validateField('email', e.target.value)
                                                }}
                                                onBlur={(e) => validateField('email', e.target.value)}
                                                disabled={isLoading}
                                            />
                                            <label className="form-label">E-mail *</label>
                                        </div>
                                        {errors.email && <span className="error-message">{errors.email}</span>}
                                    </div>

                                    {/* Campo Mensagem */}
                                    <div className="form-group">
                                        <div className="form-input-wrapper">
                                            <textarea
                                                className="form-input form-textarea"
                                                placeholder=" "
                                                rows="6"
                                                value={assunto}
                                                onChange={(e) => {
                                                    setAssunto(e.target.value)
                                                    if (errors.assunto) validateField('assunto', e.target.value)
                                                }}
                                                onBlur={(e) => validateField('assunto', e.target.value)}
                                                disabled={isLoading}
                                            ></textarea>
                                            <label className="form-label">Mensagem *</label>
                                        </div>
                                        {errors.assunto && <span className="error-message">{errors.assunto}</span>}
                                        <span className="char-count">{assunto.length}/500</span>
                                    </div>

                                    <button 
                                        type="submit" 
                                        className="btn btn-project-primary btn-send"
                                        disabled={isLoading}
                                    >
                                        <BiMailSend className="btn-icon" />
                                        {isLoading ? 'Enviando...' : 'Enviar Mensagem'}
                                    </button>
                                </form>
                            </div>

                            {/* Informações de Contato */}
                            <div className="contact-info-section">
                                <h2 className="info-title">Outros Meios de Contato</h2>
                                
                                <div className="contact-info-grid">
                                    <div className="contact-info-item">
                                        <div className="info-icon">
                                            <MdEmail />
                                        </div>
                                        <div className="info-content">
                                            <h3>E-mail</h3>
                                            <a href="mailto:leonardudesouza@outlook.com">
                                                leonardudesouza@outlook.com
                                            </a>
                                        </div>
                                    </div>

                                    <div className="contact-info-item">
                                        <div className="info-icon">
                                            <BiPhoneCall />
                                        </div>
                                        <div className="info-content">
                                            <h3>Telefone</h3>
                                            <p>(31) 98580-8502</p>
                                        </div>
                                    </div>

                                    <div className="contact-info-item">
                                        <div className="info-icon">
                                            <BiLogoWhatsapp />
                                        </div>
                                        <div className="info-content">
                                            <h3>WhatsApp</h3>
                                            <a href="https://wa.me/5531985808502?text=Olá! Vim através do seu site" target="_blank" rel="noreferrer">
                                                (31) 98580-8502
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                {/* Tempo de Resposta */}
                                <div className="response-info">
                                    <span className="response-icon">⏱️</span>
                                    <p>Normalmente respondo em <strong>24 horas</strong></p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    )
}

export default Contact
